// extracted by mini-css-extract-plugin
export var active = "_fk-2";
export var recordingDot = "_fk-1";
export var recordingIndicator = "_fk-0";